export function toDateString(dateInSeconds: number) {
  return new Date(
    new Date(dateInSeconds * 1000).toUTCString().slice(0, -4)
  ).toLocaleDateString();
}
